{
  "appName": "Vineyard Work",
  "name": "vsol-client",
  "version": "1.7.1.0"
}
